import { compareDates } from "@/utils/utils";
import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import {
  createBetslipPersistencePlugin,
  getVuexPersistFilter,
  getVuexPersistReducer,
} from "@/services/betslip-persistence";
import stateAction from "./action";
import stateBetslip from "./betslip";
import stateBalance from "./balance";

export default createStore({
  modules: {
    stateAction,
    stateBetslip,
    stateBalance,
  },
  state: {
    config: {},
    queryParams: {},
    gameMarket: [],
    gameSettings: {},
    accountSetting: {},
    nextDraws: [],
    lang: {},
    isLogin: false,
    defaultAmount: 0,
    accountKey: '',
  },
  mutations: {
    SET_CONFIG(state, config) {
      state.config = config;
    },
    SET_QUERY_PARAMS(state, payload) {
      state.queryParams = payload;
    },
    SET_GAME_MARKET(state, payload) {
      state.gameMarket = payload;
    },
    SET_ACCOUNT_SETTINGS(state, payload) {
      state.accountSetting = payload;
      state.defaultAmount= payload.bet_default
    },
    SET_GAME_SETTINGS(state, payload) {
      state.gameSettings = payload;
    },
    SET_NEXT_DRAWS(state, payload) {
      state.nextDraws = payload;
    },
    SET_LANG(state, payload) {
      state.lang = payload;
    },
    SET_LOGIN(state, payload) {
      state.isLogin = payload;
    },
    SET_ACCOUT(state, payload) {
      state.accountKey = payload
    }
  },
  actions: {},
  getters: {
    drawDate: (state) => (gameSlug: string) => {
      const drawDatesAllowSlug: any = state.nextDraws.find((x: any) => x.slug == gameSlug);
      if (drawDatesAllowSlug) {
        const drawDate = drawDatesAllowSlug.draws.filter((x: any) => compareDates(x.cutoff, new Date()) > 0);
        if (drawDate.length > 0) {
          return {
            eventId: drawDate[0].id,
            drawDate: drawDate[0].draw_date,
          };
        }
      }
    },
  },
  plugins: [
    createPersistedState({
      filter: (mutation) => getVuexPersistFilter(mutation.type),
      reducer: (state) => getVuexPersistReducer(state),
    }),
    createBetslipPersistencePlugin(),
  ],
});
